import * as variables from 'styles/base/variables.module.scss';

export const zIndexNavigation = parseInt(variables.zIndexNavigation, 10);
export const DEFAULT_SEARCH_OVERLAY_TOP = parseInt(variables.navPrimaryHeight, 10); // 44; // .Nav-primary height as per CSS
